module.exports = __webpack_public_path__ + "assets/Telecommunications.da3f260a.svg";